import type { ReactNode } from 'react';
import { Typography } from '../Typography/Typography';
import './PageHeading.css';

/** Shared page title, subtitle, and actions. */
export function PageHeading({ title, subtitle, actions, children, className = '', testId, subtitleTestId }: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  testId?: string;
  subtitleTestId?: string;
}) {
  return (
    <div className={`page-heading ${className}`}>
        <div className="page-heading__content">
          <div className="page-heading__copy">
            <Typography as="h1" role="title/page" testId={testId}>{title}</Typography>
            {subtitle && <Typography as="p" role="body/sm" testId={subtitleTestId}>{subtitle}</Typography>}
          </div>
          {actions && <div className="page-heading__actions">{actions}</div>}
          {children}
        </div>
    </div>
  );
}
